import { GroupRow } from '../types';
import { GroupEmpty } from './GroupEmpty';
import { GroupList } from './GroupList';

type GroupListTableProps = React.ComponentProps<typeof GroupList>;

type Props = {
  groups: GroupRow[];
  setGroups: React.Dispatch<React.SetStateAction<GroupRow[]>>;
  createLink: GroupListTableProps['createLink'];
  sortParams: GroupListTableProps['sortParams'];
  menuAnchorEl: GroupListTableProps['menuAnchorEl'];
  setSortParams: GroupListTableProps['setSortParams'];
  onClickRow: GroupListTableProps['onClickRow'];
  onClickMenu: GroupListTableProps['onClickMenu'];
  onCloseMenu: GroupListTableProps['onCloseMenu'];
  onClickEdit: GroupListTableProps['onClickEdit'];
  onClickDelete: GroupListTableProps['onClickDelete'];
};

/**
 * @param groups - グループ一覧
 * @param setGroups - グループ一覧を更新する関数
 * @param sortParams - ソートパラメータ
 * @param menuAnchorEl - メニューのアンカー要素
 * @param setSortParams - ソートパラメータを更新する関数
 * @param onClickMenu - メニュークリック処理
 * @param onCloseMenu - メニュークローズ処理
 * @param onClickEdit - 編集クリック処理
 * @param onClickDelete - 削除クリック処理
 */
export const GroupListPresentation: React.FC<Props> = ({
  groups,
  setGroups,
  createLink,
  sortParams,
  menuAnchorEl,
  setSortParams,
  onClickRow,
  onClickMenu,
  onCloseMenu,
  onClickEdit,
  onClickDelete,
}) => {
  if (groups.length === 0) {
    return <GroupEmpty createLink={createLink} />;
  }

  return (
    <GroupList
      groups={groups}
      setGroups={setGroups}
      createLink={createLink}
      sortParams={sortParams}
      menuAnchorEl={menuAnchorEl}
      setSortParams={setSortParams}
      onClickRow={onClickRow}
      onClickMenu={onClickMenu}
      onCloseMenu={onCloseMenu}
      onClickEdit={onClickEdit}
      onClickDelete={onClickDelete}
    />
  );
};
